import { ICON_TYPE_ROUTE_NAME_MAP } from '@/config/map'
import Vue from 'vue'
/**
 * Company: Etton Group
 * User: Nikolay Zubkov
 * Date: 05.10.2021
 * Time: 19:07
 */
class ObjectCardLinkCreator {
  static createLink(id, subLayerConfig) {
    const name = ICON_TYPE_ROUTE_NAME_MAP[subLayerConfig.iconType]
    if (!name) {
      console.error(
        'Unknown route type, please set definition in iconTypeRouteNameMap'
      )
      return null
    }
    const params = { id }
    const router = Vue.prototype.$sharedServices.router
    return (
      window.location.protocol +
      '//' +
      window.location.host +
      '/' +
      router.resolve({ name, params }).href
    )
  }
}

export default ObjectCardLinkCreator
